// Company Information Configuration
// هذا الملف يحتوي على معلومات الشركة الرسمية

export const COMPANY_INFO = {
  name: 'CloudGM FZ-LLC',
  nameAr: 'كلاود جي إم',
  
  // Contact Information
  email: 'support@cloudgm.com',
  phone: '+971501511917',
  phoneDisplay: '+971 50 151 1917',
  
  // Address
  address: {
    country: 'الإمارات العربية المتحدة',
    countryEn: 'United Arab Emirates',
    emirate: 'إمارة رأس الخيمة',
    emirateEn: 'Ras Al Khaimah',
    zone: 'راكز',
    zoneEn: 'RAKEZ',
    full: 'الإمارات العربية المتحدة، إمارة رأس الخيمة، راكز',
    fullEn: 'RAKEZ, Ras Al Khaimah, United Arab Emirates'
  },
  
  // Social Media (for future use)
  social: {
    facebook: '',
    instagram: '',
    twitter: '',
    linkedin: '',
    whatsapp: '+971501511917'
  },
  
  // Legal
  registrationNumber: '',
  vatNumber: '',
  
  // Platforms
  platforms: {
    main: {
      name: 'CloudGM',
      url: 'cloudgm.com',
      description: 'منصة الخدمات الحكومية والتجارية للأفراد'
    },
    business: {
      name: 'CloudGM Business',
      url: 'business.cloudgm.com',
      description: 'منصة الأعمال والتجار'
    }
  }
};

export default COMPANY_INFO;
